export default "__VITE_ASSET__ZGhgwUJp__"